import React from 'react'
import cn from 'classnames'
import { Badge } from '@mc/design-system'
import { Tooltip, type TooltipProps } from './Tooltip'

export interface LabelProps {
  title: React.ReactElement | string
  subtitle?: React.ReactElement | string
  badge?: React.ReactElement | string
  hasTitleHighlithed?: boolean
  tooltip?: TooltipProps
}

export const Label = ({ ...props }: LabelProps) => (
  <div
    role='cell'
    className='col-12 d-flex justify-content-center align-items-center'
  >
    <div className='d-block d-lg-none mc-text-small'>
      <LabelContent {...props} />
    </div>
    <div className='d-none d-lg-block'>
      <LabelContent {...props} />
    </div>
  </div>
)

export const LabelContent = ({
  title,
  subtitle,
  badge,
  hasTitleHighlithed,
  tooltip,
}: LabelProps) => (
  <div className='mc-pb-3 mc-text--center'>
    {title && subtitle && badge && (
      <>
        <div className='d-flex flex-column align-items-center'>
          <Badge kind='dim' className='mc-mb-2'>
            <span className='mc-text--bold'>{badge}</span>
          </Badge>
          <span className='mc-text--1-line'>{title}</span>
        </div>
        <span className='mc-opacity--hinted'>{subtitle}</span>
      </>
    )}
    {title && subtitle && !badge && (
      <>
        <div className='d-flex justify-content-center'>
          <span className='mc-text--1-line'>{title}</span>
          {tooltip && (
            <Tooltip
              iconSrText={tooltip.iconSrText}
              contentText={tooltip.contentText}
              onClick={tooltip.onClick}
            />
          )}
        </div>
        <span className='mc-opacity--hinted'>{subtitle}</span>
      </>
    )}
    {title && !subtitle && !badge && (
      <div className='d-flex justify-content-center'>
        <span
          className={cn({
            'mc-text--bold mc-text-large': hasTitleHighlithed,
          })}
        >
          {title}
        </span>
        {tooltip && (
          <Tooltip
            iconSrText={tooltip.iconSrText}
            contentText={tooltip.contentText}
            onClick={tooltip.onClick}
          />
        )}
      </div>
    )}
  </div>
)
